module.exports = __webpack_public_path__ + "static/media/stats-up.75c794a5.svg";